export default __webpack_public_path__ + "static/media/game_window.03ffa3e5.png";